export const ASL_SCADENZA_GIORNI = 30;

export function computeKpiFromMagazzino(magazzino, ospitiAttivi, meseCorrente, reportInviatiOspiti = new Set()) {
  const ospitiIds = new Set(ospitiAttivi.map((o) => o.id));
  let pacchi = 0;
  const reminderOspiti = new Set();
  const aslOspiti = new Set();

  for (const entry of magazzino) {
    const oid = entry.ospiteId;
    if (!ospitiIds.has(oid)) continue;
    let needsReminder = false;
    for (const tipo of ["pannoloni", "traverse"]) {
      const c = entry[tipo];
      if (!c || (c.consumoGiornaliero || 0) === 0) continue;
      pacchi += c.pacchiDaOrdinare || 0;
      if ((c.pacchiDaOrdinare || 0) > 0) {
        const ultimo = entry.ultimoReminderInviatoAt;
        if (!ultimo || !String(ultimo).startsWith(meseCorrente)) {
          needsReminder = true;
        }
      }
      const gg = c.giorniAllaScadenza;
      if (gg != null && gg >= 0 && gg <= ASL_SCADENZA_GIORNI) {
        aslOspiti.add(oid);
      }
    }
    if (needsReminder) reminderOspiti.add(oid);
  }

  let reportDaInviare = 0;
  for (const o of ospitiAttivi) {
    if (!reportInviatiOspiti.has(o.id)) reportDaInviare += 1;
  }

  return {
    pacchiDaOrdinare: pacchi,
    reminderDaInviare: reminderOspiti.size,
    reportDaInviare,
    fornitureAslInScadenza: aslOspiti.size,
  };
}

export function getSpesaFatturazioneBadge(spesa) {
  if (spesa.omaggio) {
    return { label: "Omaggio", className: "border-blue-200 bg-blue-50 text-blue-700" };
  }
  if (spesa.escludiDaFatturazione) {
    return { label: "Esclusa", className: "border-slate-200 bg-slate-50 text-slate-600" };
  }
  if (spesa.fatturazione_fattura_id) {
    return { label: "Inclusa in fattura", className: "border-emerald-200 bg-emerald-50 text-emerald-700" };
  }
  return { label: "Da fatturare", className: "border-amber-200 bg-amber-50 text-amber-700" };
}

export function costoUnitarioConsumo(consumo) {
  const prezzo = consumo.prezzoPacco;
  const pezzi = consumo.pezziPerPacco || 30;
  if (prezzo == null || prezzo === "") return null;
  const n = Number(prezzo);
  if (!Number.isFinite(n)) return null;
  return n / pezzi;
}

export function exportCsv(filename, headers, rows) {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const lines = [headers.map(esc).join(";"), ...rows.map((r) => r.map(esc).join(";"))];
  const blob = new Blob(["\uFEFF" + lines.join("\n")], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
